<template>
  <div class="step-infos"><div class="badge">{{ txtBadge }}</div><p><slot></slot></p></div>
</template>

<script>
  export default {
    props: ['txtBadge']
  }
</script>

<style>

  .step-infos { 
    position: relative;
    display: inline-block;
    margin: 0 0 40px;
    cursor: pointer;
  }
  
  .step-infos p {
    width: 80%;
    display: inherit;
    top: 5px;
    position: relative;
  }
  
  .step-infos .badge {
    display: inline-block;
    background: #086fab;
    border: 3px solid #403592;
    font-family: 'blogger_sansbold';
    width: 55px;
    height: 55px;
    border-radius: 150px;
    color: white;
    font-size: 36px;
    margin-right: 25px;
    text-align: center;
  }
    
</style>
